import HomePage from '../pages/home-page'
import PostCreateEditPage from '../pages/posts/post-create-edit-page'
import PostViewPage from '../pages/posts/post-view-page'
import NotificationPage from '../pages/notification-page'
import ProfilePage from '../pages/profile-page'
import StorePage from '../pages/store-page'
import StoreProductPage from '../pages/store-product-page'
import ChatPage from '../pages/chat-page'
import ChatLoginFailedPage from '../pages/chat-login-failed-page'
import RegistrationPage from '../pages/registration-page'
import LoginPage from '../pages/login-page'
import ForgotPasswordPage from '../pages/forgot-password-page'
import ResetPasswordPage from '../pages/reset-password-page'
import SettingsProfilePage from '../pages/settings-profile-page'
import SettingsAccountManagement from '../pages/settings-account-management'
import SettingsStore from '../pages/settings-store-page'
import SettingsMediaVault from '../pages/settings-media-vault-page'
import SettingsEarningDashboardPage from '../pages/settings-earning-dashboard-page'
import SettingsPurchasedPage from '../pages/settings-purchased-page'
import SettingsBecomeCreatorPage from '../pages/settings-become-creator-page'
import ShoppingCartPage from '../pages/shopping-cart-page'
import NotFoundPage from '../pages/not-found-page'
import PrivacyPolicyPage from '../pages/documents/privacy-policy-page'
import GdprCookiePolicyPage from '../pages/documents/gdpr-cookie-policy-page'
import TermsOfUsePage from '../pages/documents/terms-of-use-page'
import TermsOfSalePage from '../pages/documents/terms-of-sale-page'

const routes = [
    {
        path: '/',
        name: HomePage.name,
        component: HomePage,
        guards: ['auth', 'ready'],
    },
    {
        path: '/register',
        name: RegistrationPage.name,
        component: RegistrationPage,
        guards: ['guest'],
        meta: { layout: 'guest' },
    },
    {
        path: '/login',
        name: LoginPage.name,
        component: LoginPage,
        guards: ['guest'],
        meta: { layout: 'guest' },
    },
    {
        path: '/forgot-password',
        name: ForgotPasswordPage.name,
        component: ForgotPasswordPage,
        guards: ['guest'],
        meta: { layout: 'guest' },
    },
    {
        path: '/reset-password',
        name: 'user.password.reset',
        component: ResetPasswordPage,
        props: true,
        guards: ['guest'],
        meta: { layout: 'guest' },
    },
    {
        path: '/post/create',
        name: PostCreateEditPage.name,
        component: PostCreateEditPage,
        guards: ['auth', 'ready'],
        meta: { layout: 'post-create', customScroll: true },
    },
    {
        path: '/post/edit/:postId',
        component: PostCreateEditPage,
        props: true,
        guards: ['auth', 'ready'],
        meta: { layout: 'post-create', customScroll: true },
    },
    {
        path: '/post/:postId',
        name: PostViewPage.name,
        component: PostViewPage,
        props: true,
        guards: ['auth', 'ready'],
        meta: { class: 'post-view-page-layout' },
    },
    {
        path: '/notification',
        name: NotificationPage.name,
        component: NotificationPage,
        guards: ['auth', 'ready'],
        meta: { title: 'Notifications' },
    },
    {
        path: '/profile',
        name: ProfilePage.name,
        component: ProfilePage,
        guards: ['auth', 'ready'],
        meta: { title: 'Profile View', subLeftBar: true },
    },
    {
        path: '/user/:username',
        name: 'user-profile-page',
        component: ProfilePage,
        guards: ['auth', 'ready'],
        meta: { title: 'Profile View' },
        props: true,
    },
    {
        path: '/user/:username/store',
        name: StorePage.name,
        component: StorePage,
        props: true,
    },
    {
        path: '/user/:username/product/:productId',
        name: StoreProductPage.name,
        component: StoreProductPage,
        props: true,
    },
    {
        path: '/chat',
        name: ChatPage.name,
        component: ChatPage,
        guards: ['auth', 'ready'],
        meta: { title: 'Chats' },
    },
    {
        path: '/chat-login-failed',
        name: ChatLoginFailedPage.name,
        component: ChatLoginFailedPage,
        meta: { layout: 'blank' },
    },
    {
        path: '/cart',
        name: ShoppingCartPage.name,
        component: ShoppingCartPage,
        guards: ['auth', 'ready'],
        meta: { title: 'Shopping Cart', cartView: 'list' },
    },
    {
        path: '/cart/payment',
        component: ShoppingCartPage,
        guards: ['auth', 'ready'],
        meta: { title: 'Payment', cartView: 'payment' },
    },
    {
        path: '/settings/profile',
        name: SettingsProfilePage.name,
        component: SettingsProfilePage,
        guards: ['auth'],
    },
    {
        path: '/settings/account-management',
        name: SettingsAccountManagement.name,
        component: SettingsAccountManagement,
        guards: ['auth'],
    },
    {
        path: '/settings/store',
        name: SettingsStore.name,
        component: SettingsStore,
    },
    {
        path: '/settings/media-vault',
        name: SettingsMediaVault.name,
        component: SettingsMediaVault,
    },
    {
        path: '/settings/dashboard',
        name: SettingsEarningDashboardPage.name,
        component: SettingsEarningDashboardPage,
        guards: ['auth'],
    },
    {
        path: '/settings/purchased',
        name: SettingsPurchasedPage.name,
        component: SettingsPurchasedPage,
        guards: ['auth'],
    },
    {
        path: '/settings/become-creator',
        name: SettingsBecomeCreatorPage.name,
        component: SettingsBecomeCreatorPage,
        guards: ['auth'],
    },
    {
        path: '/privacy-policy',
        name: PrivacyPolicyPage.name,
        component: PrivacyPolicyPage,
        meta: {
            layout: 'document',
        },
    },
    {
        path: '/cookie-policy',
        name: GdprCookiePolicyPage.name,
        component: GdprCookiePolicyPage,
        meta: {
            layout: 'document',
        },
    },
    {
        path: '/terms-of-use',
        name: TermsOfUsePage.name,
        component: TermsOfUsePage,
        meta: {
            layout: 'document',
        },
    },
    {
        path: '/terms-of-sale',
        name: TermsOfSalePage.name,
        component: TermsOfSalePage,
        meta: {
            layout: 'document',
        },
    },
    {
        path: '*',
        component: NotFoundPage,
        meta: {
            layout: 'not-found',
            title: '404',
            description: 'Sorry, the content you are looking for doesn’t exist.<br/>Either it was removed, or you mistyped the link.',
        },
    },
]

export default routes
